import { render, staticRenderFns } from "./-cart.vue?vue&type=template&id=4456bebc&scoped=true&"
import script from "./-cart.vue?vue&type=script&lang=js&"
export * from "./-cart.vue?vue&type=script&lang=js&"
import style0 from "./-cart.vue?vue&type=style&index=0&id=4456bebc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4456bebc",
  null
  
)

export default component.exports